import { BrandSelector } from '@seek/branding-assets';
import { useHirerAuth } from '@seek/hirer-auth-react';
import { useTranslations } from '@vocab/react';
import { Stack } from 'braid-design-system';
import { shallowEqual, useSelector } from 'react-redux';

import { isProd } from 'src/app/utils/environment';
import { BrandingContextualHelp } from 'src/app/v1/views/components/BrandingContextualHelp';
import { FieldHeading } from 'src/app/v1/views/components/FieldHeading';
import { ProductFeatureBadge } from 'src/app/v1/views/components/ProductFeatureBadge';
import type { AppState } from 'src/types/appState';

import translations from './../../../../.vocab';

interface PaywallBrandingProps {
  shouldPaywallBrandingBeShown: boolean;
}

export const PaywallBranding = ({
  shouldPaywallBrandingBeShown,
}: PaywallBrandingProps) => {
  const { t } = useTranslations(translations);
  const { isPrivateAdvertiser } = useSelector(
    (state: AppState) => ({
      isPrivateAdvertiser: state.session.hirerAccount?.isPrivateAdvertiser,
    }),
    shallowEqual,
  );
  const { getToken } = useHirerAuth();

  const onBrandSelected = () => {};

  if (!shouldPaywallBrandingBeShown) {
    return null;
  }

  return (
    <Stack space="small">
      <ProductFeatureBadge />
      <Stack space="xsmall">
        <FieldHeading
          heading={
            <>
              {t('write-page-branding-section-heading')}
              {` `}
              {isPrivateAdvertiser ? null : <BrandingContextualHelp />}
            </>
          }
          secondaryHeading={t('write-page-branding-section-secondary-heading')}
        />

        <BrandSelector
          getToken={getToken}
          isProd={isProd()}
          onBrandSelected={onBrandSelected}
          tileRowCount={3}
        />
      </Stack>
    </Stack>
  );
};
